import {useMemo} from 'react';
import {formatPriceNumber} from 'core/helpers';
import {useIsPrive} from 'core/hooks/useIsPrive';
import {IProduct} from 'modules/product-card/models/ProductResponse';

export const useProductBasePrice = (product?: IProduct | null) => {
    const isPrive = useIsPrive();

    // eslint-disable-next-line complexity
    return useMemo(() => {
        if (!product) {
            return '';
        }

        const {
            canBuy,
            canReserve,
            price: {
                base: {price: basePrice},
                discount: {price: discountPrice},
                isSpecPrice,
                specPrice,
            },
        } = product;

        const shouldShowBasePrice = (!canBuy && !canReserve) || (isPrive && !canBuy && canReserve);

        if (shouldShowBasePrice) {
            return formatPriceNumber(basePrice);
        }

        if (!basePrice) {
            return '';
        }

        if (!isSpecPrice && basePrice === discountPrice) {
            return '';
        }

        if (isSpecPrice && specPrice === basePrice) {
            return '';
        }

        return formatPriceNumber(basePrice);
    }, [isPrive, product]);
};
